import { ViewContainerRef } from '@angular/core';
import { CruiseService } from '../services/cruise.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';

declare var jQuery: any;

@Component({
    selector: 'cruise-itinerary',
    templateUrl: './cruise-itinerary.component.html',
    styleUrls: ['./flights-itinerary.component.css']
})
export class CruiseItineraryComponent implements OnInit {
    public resremarks: any;
    public remarks: any;
    public paxid: any = '';
    public mobileSEND: any = '';
    public EmailSEND: any = '';
    public PNR: any = '';
    public Deck: any = '';
    public Cabin: any = '';
    public bookingList: any = {};
    public paxin: any[] = [];
    public paxout: any = '';
    public paxinb: any = '';
    public agent: any = {};
    public transactionId: any;
    public Source: any = "";
    public Destination: any = "";
    public ticketUrls: any = "";
    public trans: any = "";
    public RemarksRelease: any = "";
    public RemarksExtended: any = "";
    public Remarks: any = "";
    public Days: any = "";
    public Date: any = "";
    public Status: any = "";
    public bookingLogs: any[] = [];
    //private baseUrl: any = AppConstants.siteUrl;
    public Cruisedata: any = {};
    public paxdata: any = {};
    public mobile: any = "";
    public CancelTicketr: any = "";
    public Email: any = "";
    public WithFare: any = "";
    public AddMarkup: any = "";
    public WithoutFare: any = "";
    public noagency: any = "";
    public In: any = "";
    public Out: any = "";
    private Totaltax: any = 0; private baseURL: any = '';
    public Faretype: any = "";
    public invoiceUrls: any = ""; public last_access: Date;
    public custinvoiceUrls: any = ""; public imageURL = ''; public loginType = '';
    public merchantsetup: any = {}; private title: any = ''; public logintype: any = ""; public agentcode: any = ""; public agentid: any = "";
    checkAllNonTrades: boolean = false
    constructor(@Inject(PLATFORM_ID) private platformId: Object, platformLocation: PlatformLocation, private cruiseService: CruiseService, private _location: Location, private toastr: ToastrService, private router: ActivatedRoute, private route: Router, public vcr: ViewContainerRef, private titleService: Title, private meta: Meta) {
        //this.merchantsetup = this.cruiseService.getSetupData();
        if (isPlatformBrowser(this.platformId)) this.baseURL = (platformLocation as any).location.origin;
        this.router.params.subscribe(
            data => {
                this.transactionId = data.txId;
            })

        this.loginType = this.cruiseService.getloginType();
    }

    ngOnInit() {

        // Check for last access if it is more than 30 mins then expire session
        if (this.loginType == "B2B") {
            if (isPlatformBrowser(this.platformId)) {
                if (sessionStorage.getItem("last_access")) {
                    this.last_access = new Date(Number(sessionStorage.getItem("last_access")));
                    var diff = this.diff_minutes(this.last_access, new Date());
                    if (diff > 20) {
                        sessionStorage.clear();
                        this.toastr.warning("Your session expired, Pl re-login...!");
                    }
                } else {
                    var d = new Date();
                    sessionStorage.setItem("last_access", JSON.stringify(d.getTime()));
                }
            }
        }

        this.getBookingList();
        //this.merchantsetup = this.cruiseService.getSetupData();
        // this.titleService.setTitle("Book Cruise Tour Packages with Akbar Travels");
        this.meta.addTag({ name: 'author', content: 'http://www.influencetechnolabs.com/' });
        // this.titleService.setTitle(this.title);

        if (isPlatformBrowser(this.platformId)) {
            if (sessionStorage.getItem("logindata")) {
                this.agent = JSON.parse(JSON.parse(sessionStorage.getItem("logindata")));
                this.logintype = this.agent.Type;
                this.agentcode = this.agent.CompanyCode;
                this.agentid = this.agent.AgentUserLoginId;
                this.imageURL = "https://s3.ap-south-1.amazonaws.com/b2badminstorage/AGENT_LOGO/" + this.agentcode + ".png?" + Math.round((Math.random() * 100000) * 100);
            }
            else {
                this.toastr.warning("You don't have permission to view this...!");
                setTimeout(() => {
                    this.route.navigate([""]);
                }, 2000);
            }
        }
        if (this.logintype == "OO" || this.logintype == "OO") this.imageURL = "https://lccintl.ezeeibe.com/cruisextranet/akbar-logo.png";
    }

    keyPress(event: any) {
        const pattern = /[0-9\ ]/;

        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    showTicket(txId) {
        this.ticketUrls = this.merchantsetup.siteUrl + "/cruise/voucher/" + txId + "/success";
        //this.ticketUrls = "http://localhost:4200/confirmPayment/" + txId + "/success";
        //this.route.navigate([]).then(result => { window.open(this.ticketUrls, '_blank'); });
        if (this.baseURL.indexOf("akbartravels") > -1) this.trans = environment.portalURL + "/cruise/voucher/" + txId + "/success";
        else this.trans = "cruise/voucher/" + txId + "/success";

        this.route.navigate([this.trans]);
    }
    showcustInvoice(txId) {
        this.custinvoiceUrls = this.merchantsetup.siteUrl + "flight/invoice/" + txId + "/C";
        //this.route.navigate([]).then(result => { window.open(this.custinvoiceUrls, '_blank'); });
        //this.custinvoiceUrls = "http://localhost:4200/flight/invoice/" + txId + "/C";
        this.trans = environment.portalURL + "/flight/invoice/" + txId + "/C";
        this.route.navigate([this.trans]);
    }
    backClicked() {
        this._location.back();
    }
    getBookingList() {
        this.cruiseService.cruisedetails(this.transactionId, this.agent).subscribe(
            data => {
                var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                this.bookingList = resp.bookingReport[0];
                this.Cruisedata = this.cruiseService.getDecrypt(this.bookingList.cruiseData);
                this.paxdata = this.cruiseService.getDecrypt(this.bookingList.agentData);
                if (isPlatformBrowser(this.platformId)) sessionStorage.setItem("cruisebookingList", JSON.stringify(this.bookingList));
            }, error => {

            }
        )
    }
    getBookingLogs() {
        this.cruiseService.cruiselogs(this.transactionId, this.agent, this.bookingList.CruiseLine).subscribe(
            data => {
                var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                this.bookingLogs = resp.bookingLogs;
            }, error => {

            }
        )
    }

    CancelTicket() {
        if (!this.remarks) {
            this.toastr.warning("Please provide Some Text...!");
            return false;
        }
        this.cruiseService.updatepnr(this.transactionId, this.agentcode, this.logintype, this.remarks, "", "", "reject").subscribe(
            data => {
                var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                var bookingList = resp;
                if (bookingList.status == 'Failed') {
                    this.toastr.warning("Couldn't Update the PNR ....");
                    return false;
                }
                if (bookingList.status == 'Success') {
                    jQuery("#CancelTicket").modal("hide");
                    jQuery('#CancelTicket').addClass("disabledbutton");
                    this.toastr.success("Record Updated Successfully ! ....");
                }
            }
        )
    }
    emaileTicket() {

        if (!this.EmailSEND) {
            this.toastr.warning("Please provide Email/Mobile...!")
            return false;
        }
        this.cruiseService.voucheremail(this.transactionId, this.EmailSEND).subscribe(
            data => {
                if (JSON.parse(JSON.stringify(data)).d) {
                    var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    if (resp.status == 'Failed') {
                        this.toastr.warning("Something is wrong ....");
                        return false;
                    }
                    if (resp.status == 'Success') {
                        jQuery("#sendemail").modal("hide");
                        this.toastr.success("Record Updated Successfully ! ....");
                    }
                    console.log(resp);
                }
            }, error => {

            }
        )
    }
    UPDATEPNR() {
        if (!this.PNR) {
            this.toastr.warning("Please provide PNR...!");
            return false;
        }
        if (!this.Deck) {
            this.toastr.warning("Please provide Deck...!");
            return false;
        }
        if (!this.Cabin) {
            this.toastr.warning("Please provide Cabin...!");
            return false;
        }
        this.cruiseService.updatepnr(this.transactionId, this.agentcode, this.logintype, this.PNR, this.Deck, this.Cabin, "update").subscribe(
            data => {
                var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                var bookingList = resp;
                if (bookingList.status == 'Failed') {
                    this.toastr.warning("Something is wrong ....");
                    return false;
                }
                if (bookingList.status == 'Updated Succesfully') {
                    jQuery("#CancelTicket").modal("hide");
                    jQuery('#CancelTicket').addClass("disabledbutton");
                    this.toastr.success("Record Updated Successfully ! ....");
                }
            }
        )
    }
    pnrupdate(txId) {
        this.invoiceUrls = this.merchantsetup.siteUrl + "flight/updatepnr/" + txId;
        this.trans = environment.portalURL + "/flight/updatepnr/" + txId;
        this.route.navigate([this.trans]);
    }


    diff_minutes(dt2: Date, dt1: Date) {
        var diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    }

    // Extended() {
    //     this.cruiseService.Extend(this.transactionId, "HOLD", this.Date, this.Days, this.Remarks, this.agent.uid, this.agent.Type, this.agent.AgencyName, "Edit", "cruiseupdate").subscribe(
    //         data => {
    //             var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
    //             var bookingList = resp;
    //             this.bookingList.SalesTax = this.Totaltax;
    //             jQuery("#Extended").modal("hide");
    //             if (bookingList.status == 'Failed') {
    //                 this.toastr.warning("Something is wrong ....");
    //                 return false;
    //             }
    //             if (bookingList.status == 'Record Updated Successfully') {
    //                 sessionStorage.removeItem("txn:" + this.transactionId);
    //                 this.getBookingList();
    //                 this.toastr.success("Record Updated Successfully ! ....");

    //             }
    //         }
    //     )
    //     this.getBookingList()
    // }
    // Release() {
    //     this.cruiseService.Releas(this.transactionId, "RELEASE", this.Date, "", this.Remarks, this.agent.uid, this.agent.Type, this.agent.AgencyName, "Edit", "cruiseupdate").subscribe(
    //         data => {
    //             var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
    //             var bookingList = resp;
    //             this.bookingList.SalesTax = this.Totaltax;
    //             jQuery("#Release").modal("hide");
    //             if (bookingList.status == 'Failed') {
    //                 this.toastr.warning("Something is wrong ....");
    //                 return false;
    //             }
    //             if (bookingList.status == 'Record Updated Successfully') {
    //                 sessionStorage.removeItem("txn:" + this.transactionId);
    //                 this.getBookingList();
    //                 this.toastr.success("Record Updated Successfully ! ....");

    //             }
    //         }
    //     )
    //     this.getBookingList()
    // }
    // confirm() {
    //     this.cruiseService.confirmd(this.transactionId, "CONFIRMED", this.Date, "", this.Remarks, this.agent.uid, this.agent.Type, this.agent.AgencyName, "Edit", "cruiseupdate").subscribe(
    //         data => {
    //             var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
    //             var bookingList = resp;
    //             this.bookingList.SalesTax = this.Totaltax;
    //             jQuery("#confirm").modal("hide");
    //             if (bookingList.status == 'Failed') {
    //                 this.toastr.warning("Something is wrong ....");
    //                 return false;
    //             }
    //             if (bookingList.status == 'Record Updated Successfully') {
    //                 sessionStorage.removeItem("txn:" + this.transactionId);
    //                 this.getBookingList();
    //                 this.toastr.success("Record Updated Successfully ! ....");

    //             }
    //         }
    //     )
    //     this.getBookingList()
    // }

    changeTradesByCategory(event) {
        var paxouts = '';
        if (event.target.checked == true) {
            paxouts = event.target.value + ",";
            this.paxout += paxouts;
        }
        else if (event.target.checked == false) {
            this.paxout = this.paxout.replace(event.target.value + ',', '')
        }


    }
    changeCategory(event) {
        var paxins = '';
        if (event.target.checked == true) {
            paxins += event.target.value + ",";
            this.paxinb += paxins;
        }
        else if (event.target.checked == false) {
            this.paxinb = this.paxinb.replace(event.target.value + ',', '')
        }
    }

}
